import { render, staticRenderFns } from "./ExamExceptionTable.vue?vue&type=template&id=67939ca1"
import script from "./ExamExceptionTable.vue?vue&type=script&lang=js"
export * from "./ExamExceptionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports